import moment from "moment";

const useSkiSeasonDates = () => {
  // get the dates for either the current or up coming ski season
  let start = moment().month(11).date(1).add(-1, "y").startOf("day");
  let end = moment().month(3).date(30).endOf("day");
  if (moment() > end) {
    start = start.add(1, "y");
    end = end.add(1, "y");
  }
  return {
    start,
    end,
  };
};

export default useSkiSeasonDates;
